// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck
import createSvgIcon from '../utils/createSvgIcon';
import React from "react";


export default createSvgIcon(
  <><path d="M3.000 7.500 L 3.000 8.000 12.000 8.000 L 21.000 8.000 21.000 7.500 L 21.000 7.000 12.000 7.000 L 3.000 7.000 3.000 7.500 M3.000 12.500 L 3.000 13.000 12.000 13.000 L 21.000 13.000 21.000 12.500 L 21.000 12.000 12.000 12.000 L 3.000 12.000 3.000 12.500 M3.000 17.500 L 3.000 18.000 12.000 18.000 L 21.000 18.000 21.000 17.500 L 21.000 17.000 12.000 17.000 L 3.000 17.000 3.000 17.500 " stroke="none" fill="black" fillRule="evenodd"></path></>, 
'MenuIcon', {
  viewBox: '0 0 24 24',
  height: '24',
  width: '24',
});